export interface EnteralDietResponse {
  administration: string,
  administrationRoute: string,
  administrationType: string,
  applicationTime: string,
  dosageType: string,
  dose: number,
  duration: string,
  durationType: string,
  endDate: moment.Moment,
  enteralDiet: string,
  enteralDietType: string,
  hours: string,
  id: number,
  infusionBomb: string,
  infusionSpeed: number,
  interval: string,
  justification: null,
  material: string,
  materialId: number,
  measurementUnit: string,
  measurementUnitId: string,
  observation: null,
  orientation: string,
  prescriberDt: string,
  prescriberName: string,
  startDate: moment.Moment,
  startPauseDate: string,
  totalVolume: number
}

export enum EnteralDietTypes {
  CONTINUOUS = 'C',
  INTERMITTENT = 'I'
}